
/* ===== VELANTIS_ACCOUNT — historial, búsquedas, recomendados, lanzamientos ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function CAT(){return window.VELANTIS_CAT||[];}
  function findByName(n){return CAT().filter(function(r){return r[0]===n;})[0]||null;}
  function get(k){try{return JSON.parse(localStorage.getItem(k)||'[]');}catch(e){return [];}}
  function set(k,v){try{localStorage.setItem(k,JSON.stringify(v.slice(0,12)));}catch(e){}}
  function pushUniq(k,val){ if(!val)return; var a=get(k).filter(function(x){return x!==val;}); a.unshift(val); set(k,a); }

  // ----- tracking -----
  window.addEventListener('hashchange',function(){
    var m=(location.hash||'').match(/^#\/p\/(.+)$/);
    if(m){ try{ pushUniq('velantis_hist', decodeURIComponent(m[1])); }catch(e){} }
  });
  var _t;
  document.addEventListener('input',function(e){
    var id=e.target && e.target.id;
    if(['gsInput','xfSearch','catSearch','evSearch'].indexOf(id)<0) return;
    clearTimeout(_t); var v=(e.target.value||'').trim();
    _t=setTimeout(function(){ if(v.length>=2) pushUniq('velantis_search', v); }, 900);
  });

  // ----- render dentro del panel -----
  function openProd(name){ location.hash='#/p/'+encodeURIComponent(name); var ov=document.getElementById('acOv'); if(ov)ov.classList.remove('show'); document.body.style.overflow=''; }
  function histRow(r){
    return '<div class="ac-hist-i" data-open="'+esc(r[0])+'">'+
      '<div class="ac-hist-img n-'+esc(r[9])+'"></div>'+
      '<div class="ac-hist-x"><div class="ac-hist-code">'+esc(r[12]||'')+'</div>'+
        '<div class="ac-hist-nm">'+esc(r[0])+'</div>'+
        '<div class="ac-hist-h">'+(r[2]?'Inspirado en · '+esc(r[2]):'')+'</div></div></div>';
  }
  function recommend(hist){
    var cat=CAT(); if(!cat.length) return [];
    var fam=null; for(var i=0;i<hist.length;i++){ var r=findByName(hist[i]); if(r){fam=r[3];break;} }
    if(!fam) return [];
    var seen={}; hist.forEach(function(n){seen[n]=1;});
    return cat.filter(function(r){return r[3]===fam && !seen[r[0]] && r[1]!=='Ambiental';}).slice(0,3);
  }
  function render(){
    var box=document.getElementById('acDyn'); if(!box) return;
    var hist=get('velantis_hist'), searches=get('velantis_search');
    var histRows=hist.map(findByName).filter(Boolean).slice(0,4);
    var recs=recommend(hist);
    var html='';
    // PRIVÉ
    html+='<a class="ac-prive" href="#/prive" data-prive><span class="ac-prive-ic">✦</span>'+
      '<span><b>Velantis Privé</b><span>Únete al círculo privado por WhatsApp</span></span></a>';
    // historial
    if(histRows.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Visto recientemente</div><div class="ac-hist">'+
        histRows.map(histRow).join('')+'</div></div>';
    }
    // recomendados
    if(recs.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Recomendados para ti</div><div class="ac-hist">'+
        recs.map(histRow).join('')+'</div></div>';
    }
    // aromas buscados
    if(searches.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Aromas que buscaste</div><div class="ac-chips">'+
        searches.slice(0,8).map(function(q){return '<span class="ac-chip" data-q="'+esc(q)+'">'+esc(q)+'</span>';}).join('')+'</div></div>';
    }
    // 4-sep: la seccion «Nuevos lanzamientos» (Novedades 2026 + Preventa del mes) se retiro del panel Mi cuenta a peticion de la casa.
    box.innerHTML=html;
  }

  // interacciones dentro del panel
  document.addEventListener('click',function(e){
    var hi=e.target.closest && e.target.closest('.ac-hist-i'); if(hi){ openProd(hi.getAttribute('data-open')); return; }
    var ch=e.target.closest && e.target.closest('.ac-chip'); if(ch){ var q=ch.getAttribute('data-q');
      var gs=document.getElementById('gsInput'); if(gs){ var ov=document.getElementById('acOv'); if(ov)ov.classList.remove('show');
        var so=document.getElementById('gsOv'); if(so){so.classList.add('show'); document.body.style.overflow='hidden';}
        gs.value=q; gs.dispatchEvent(new Event('input',{bubbles:true})); gs.focus(); } return; }
    var pv=e.target.closest && e.target.closest('[data-prive]'); if(pv){ var ov2=document.getElementById('acOv'); if(ov2)ov2.classList.remove('show'); document.body.style.overflow=''; }
  });

  // re-render al abrir el panel (icono perfil) y al cargar
  var perfil=document.querySelector('.tools .icon-btn[aria-label="Mi perfil"]');
  if(perfil) perfil.addEventListener('click',function(){ setTimeout(render,30); });
  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded',render);
})();
